import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Table } from './models/table';

@Injectable({
  providedIn: 'root'
})
export class AskServerService {
  Tables = this.socket.fromEvent<Table[]>('dataSend');
  confirmTableSend = this.socket.fromEvent<any>('confirmTableSend');
  actions = this.socket.fromEvent<any>('countActions');
  actionsByTable = this.socket.fromEvent<any>('actionsByTable');

  constructor(private socket: Socket) {}

  /* Order Delivered by waiter */
  public appelServeur(actionId: number, actionName: string) {
    this.socket.emit('appelServeur', {
      actionId: actionId,
      actionName: actionName
    });
  }

  public recupTables() {
    this.socket.emit('recupTables');
  }

  public editTable(data: object) {
    this.socket.emit('editTable', data);
  }

  public ouvertureTable(idTable: string, type: string) {
    this.socket.emit('ouvertureTable', { idTable: idTable, type: type });
  }

  public supprTable(idTable: string) {
    this.socket.emit('supprTable', idTable);
  }
  public getActions() {
    this.socket.emit('getActions');
  }
  public getActionsByTable() {
    this.socket.emit('getActionsByTable');
  }
}
